import React, { useEffect, useRef } from 'react';
import PlaceCard from './PlaceCard';

function PlaceCardList({ user, loading, places, handlePlaceCardClick, handleLocationIconClick, 
  handleSelectIconClick, handleRemoveIconClick, selectedPlace, selectedList, routeMode }) {
  const placeCardsRef = useRef({});

  useEffect(() => {
    if (selectedPlace && placeCardsRef.current[selectedPlace.reference]) {
      placeCardsRef.current[selectedPlace.reference].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }
  }, [selectedPlace]);

  return (
    <div className="place-cards">
      {loading && (
        <div className="loading-card">
          <div className="card-content">
            <h3>Loading places...</h3>
          </div>
        </div>
      )}
      {!loading && places.length === 0 && (
        <div className="no-places-card">
          <div className="card-content">
            <h3>No places found</h3>
            <p>Try moving the map to explore different areas</p>
          </div>
        </div>
      )}
      {!loading && places.map((place, index) => (
        <div key={place.id || index} ref={el => placeCardsRef.current[place.reference] = el}>
          <PlaceCard
            user={user}
            place={place}
            handlePlaceCardClick={handlePlaceCardClick}
            handleLocationIconClick={handleLocationIconClick}
            handleSelectIconClick={handleSelectIconClick}
            handleRemoveIconClick={handleRemoveIconClick}
            selectedList={selectedList}
            index={index}
            routeMode={routeMode}
          />
        </div>
      ))}
    </div>
  );
}

export default PlaceCardList;
